module.exports = __webpack_public_path__ + "img/threesides-direct.3d237ff.svg";